export default __webpack_public_path__ + "static/Bronzed-72b8e7fa686d52bf1192f2b1fed24cd2.png";